import React, { Component } from 'react';
import ContentConverter from '../../../utils/contentConverter';
import { PaddedSection, PlayButton, YouTubePlayer } from '../../atoms';
import classNames from 'classnames';
import { Modal } from '../../molecules';
import { Link } from 'react-router-dom';

import './styles.css';
import Markdown from 'markdown-to-jsx';

/**
 * VideoBoxWithText Component
 *
 * @typedef {Object} Props
 * @prop {string} heading - Heading text
 * @prop {string} videoId - YouTube video ID
 * @prop {Object} image - Image object
 * @prop {string} image.src - Image source path
 * @prop {string} image.youTubeSrc - Youtube Image source path
 * @prop {string} image.alt - Image alt text
 * @prop {string | string[]} [content] - Content to display, can be a string or array of strings
 * @prop {string} [className] - Optional CSS class name
 * @prop {boolean} [reversed] - Optional reversed layout
 * @prop {string} [href] - Optional link URL
 * @prop {string} [buttonLabel] - Optional button label text
 *
 * @augments {Component<Props>}
 */
export default class VideoBoxWithText extends Component {
	constructor (props) {
		super(props);
		this.state = {
			videoOpen: false,
		};
	}

	handleCloseModal = () => {
		this.setState({ videoOpen: false });
	};

	handleShowModal = () => {
		this.setState({ videoOpen: true });
	};

	getContent = (content) => {
		return new ContentConverter(content).convertLinks().nlToBr().getHtml();
	};

	genClassName = (props) => classNames('VideoBoxWithText', props);

	render () {
		const {
			content,
			heading,
			videoId,
			image,
			reversed,
			href,
			buttonLabel,
			className,
		} = this.props;

		const { videoOpen } = this.state;

		const imageUrl = image.youTubeSrc ? image.youTubeSrc : require(`../../../assets/images/${image.src}`);

		return (
			<PaddedSection className={
				this.genClassName({
					[className || '']: className,
					reversed,
				})}>
				<div className='innerWrap'>
					<div className='contentWrap'>
						<h3 className='heading'>{heading}</h3>
						{content ? <div className='content'>
							{Array.isArray(content) ? (
								content.map((item) => (
									<p key={item}>
										<Markdown
											options={{
												overrides: {
													Link: {
														component: Link,
													},
												},
											}}
										>
											{this.getContent(item)}
										</Markdown>
									</p>
								))
							) : (
								<p>
									<Markdown
										options={{
											overrides: {
												Link: {
													component: Link,
												},
											},
										}}
									>
										{this.getContent(content)}
									</Markdown>
								</p>
							)}
						</div> : null}
						{href && buttonLabel ? (
							<a
								className='Button'
								href={href}
							>
								<span>{buttonLabel}</span>
							</a>
						) : null}
					</div>
					<div className='videoWrap'>
						<div className='video'>
							<span className='VideoButton'>
								<PlayButton onClick={this.handleShowModal} />
							</span>
							<img src={imageUrl} alt={image.alt} />
						</div>
					</div>
				</div>
				<Modal onClose={this.handleCloseModal} show={!!videoOpen}>
					{videoId && (
						<YouTubePlayer className='youtube-video' videoId={videoId} isToggled />
					)}
				</Modal>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/VideoBoxWithText/VideoBoxWithText.js